module.exports = __webpack_public_path__ + "assets/133be17e8349f28f252ed0c7dc451c00.png";